<ul class="wm-default-menu more-actions-menu dropdown-menu">
    <!-- <span class=" caret wms wms-caret-left"></span> -->
    <li title="{{locale.LABEL_UPDATE_SOURCE}}">
        <a *wmsFeature="preferences?.project?.actions?.sources?.import" (click)="reimportProject()"
            name="wm-project-update">
            <i class="wms wms-update"></i><span class="menu-name">{{locale.LABEL_PROJECT_SRC}}</span>
        </a>
    </li>
    <li role="separator" class="divider"></li>
    <li title="{{locale.LABEL_SHORTCUTS}}">
        <a name="wm-shortcut" (click)="showShortcutsDialog()">
            <i class="wms wms-file"></i><span class="menu-name">{{locale.LABEL_SHORTCUTS}}</span>
        </a>
    </li>
    <li title="{{locale.LABEL_EDIT}} App.css" *ngIf="!projectService.isTemplateBundleType()&&!(this.projectService.projectEdnDetails?.roles?.length===1&&this.projectService.projectEdnDetails?.roles[0]?.roleName==='Default')">
        <a name="wm-edit-app-style" (click)="savetabcontent($event); editAppCss()">
            <i class="wms wms-file-css"></i><span class="menu-name">{{locale.LABEL_EDIT}} App.css</span>
        </a>
    </li>
    <li title="{{locale.LABEL_EDIT}} App.js" *ngIf="!projectService.isTemplateBundleType()&&!(this.projectService.projectEdnDetails?.roles?.length===1&&this.projectService.projectEdnDetails?.roles[0]?.roleName==='Default')">
        <a name="wm-edit-app-js" (click)="savetabcontent($event); editAppJs()">
            <i class="wms wms-file-js"></i><span class="menu-name">{{locale.LABEL_EDIT}} App.js</span>
        </a>
    </li>
    <li title="{{locale.LABEL_ISSUES}}">
        <a name="wm-inspect-app" (click)="showIssuesTab()">
            <i class="wms wms-search"></i><span class="menu-name">{{locale.LABEL_ISSUES}}</span>
          <span class="new-feature" *ngIf="!issuesService.isFirstChecked">{{locale.LABEL_NEW | uppercase}}</span>
        </a>
    </li>
</ul>
